<script>
import { storeToRefs } from 'pinia';
import { useVisitStore } from '../../../store/contact/VisitStore';

export default {
    setup() {
        const store = useVisitStore();
        const { setSchedule } = store;
        const { selectedSchedule, scheduleList } = storeToRefs(store);
        return {
            setSchedule,
            selectedSchedule,
            scheduleList,
        };
    },
};
</script>
<template>
    <div>
        <div class="fs-24px tw-text-darkGreen mb-15px">
            What schedule is more convenient for you?
        </div>
        <div class="tw-grid tw-grid-cols-2 tw-gap-3 mb-50px tw-max-w-[480px]">
            <div
                class="tw-relative"
                :class="
                    selectedSchedule == schedule.id
                        ? 'schedule-button__active'
                        : 'schedule-button__default'
                "
                v-for="schedule in scheduleList"
            >
                    <div
                        class="tw-mb-2 tw-w-[100%] tw-mb-[0px] tw-h-[100%]
                        tw-appearance-none tw-bg-white tw-p-[15px] tw-cursor-pointer
                        fs-20px fw-semibold text-center"
                        @click="setSchedule(schedule.id)"
                    >
                        <span v-if="schedule.id == 0" class="d-flex flex-column justify-content-center tw-leading-tight tw-h-[100%]">
                            <span><i class="fa-solid fa-cloud-sun fs-25px"></i></span>
                            <span class="tw-tracking-wider">AM</span>
                        </span>
                        <span v-if="schedule.id == 1" class="d-flex flex-column justify-content-center tw-leading-tight tw-h-[100%]">
                            <span><i class="fa-solid fa-cloud-moon fs-25px"></i></span>
                            <span class="tw-tracking-wider">PM</span>
                        </span>
                    </div>
            </div>
        </div>

        <!-- REMOVED [OLWDD25-289]
        <div class="tw-grid md:tw-grid-cols-2 md:tw-gap-3 tw-mb-4">
            <div
                class="tw-relative"
                :class="
                    selectedSchedule == schedule.id
                        ? 'tw-outline tw-outline-[#7c826b] tw-outline-2'
                        : ''
                "
                v-for="schedule in scheduleList"
            >
                <img
                    :src="schedule.image"
                    alt="schedule"
                    class="tw-w-full tw-h-full"
                />
                <div class="tw-absolute tw-h-full tw-w-full tw-top-0">
                    <div
                        class="tw-w-full tw-h-full tw-flex tw-items-end tw-justify-center"
                    >
                        <button
                            class="next-button tw-border-none tw-mb-2"
                            @click="setSchedule(schedule.id)"
                        >
                            Select
                        </button>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</template>